// src/context/AuthContext.tsx
import React, { createContext, useContext, useState, useEffect } from "react";
import { isAuthenticated, getUser } from "@/lib/utils";

interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  token: string;
}

interface AuthContextType {
  user: User | null;
  setUser: (user: User | null) => void;
  isAuthenticated: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    if(isAuthenticated()){
      setUser(getUser());
    }
    else{
      localStorage.removeItem("currentUser");
      sessionStorage.clear();
    }
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, isAuthenticated: isAuthenticated() }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
